import React, { useEffect } from 'react';
import { useLocation, Outlet } from 'react-router-dom';

import analytics from 'utils/analytics';

function trackPageView() {
  // Without set timeout, the title sent with pageview is of the previous page
  // because react helmet updates the title after pageview is triggered.
  // This hack has been confirmed to work on the below stackoverflow post
  // https://stackoverflow.com/a/49322315
  setTimeout(() => analytics.pageview(), 0);
}

function HistoryListener({ children }) {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname) trackPageView();
  }, [location.pathname]);

  return children ?? <Outlet />;
}

export default HistoryListener;
